export enum PaymentsType {
    'credits' = 'credits',
    'memberships' = 'memberships'
}